import { ChevronDown } from 'lucide-react'
import type { ComponentProps } from 'react'
import { cn } from '@/lib/cn'

/**
 * Native select for long lists (countries) where typing to jump matters. `pill` is the compact
 * filter shape for a page's toolbar ("All websites").
 */
export function NativeSelect({
  className,
  children,
  pill = false,
  ...props
}: ComponentProps<'select'> & { pill?: boolean }) {
  return (
    <div className={cn('relative', pill && 'inline-flex')}>
      <select
        className={cn(
          'w-full appearance-none border border-border-strong bg-surface-raised text-ink outline-none',
          pill ? 'h-9 rounded-full pr-8 pl-3.5 text-[13px] font-medium' : 'h-10 rounded-md pr-9 pl-3 text-sm',
          'focus-visible:border-ink focus-visible:ring-4 focus-visible:ring-focus/25 aria-invalid:border-danger',
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        className={cn(
          'pointer-events-none absolute top-1/2 -translate-y-1/2 text-ink-subtle',
          pill ? 'right-[11px] size-3.5' : 'right-3 size-4',
        )}
        aria-hidden="true"
      />
    </div>
  )
}
